type ItemNumber = string | number | undefined;

/**
 * The number the `#` column of the products table shows. It is not the same field for every
 * declaration type, and not the row position either: a sorted or paged table moves the rows, the
 * number stays with the item.
 */
const getProductItemNumber = (product: any): ItemNumber =>
    product?.goodsItemNumber ??
    product?.declarationGoodsItemNumber ??
    product?.governmentAgencyGoodsItem?.sequenceNumeric;

export default getProductItemNumber;
